<div class="mat-elevation-z8 table-container">
  <table (matSortChange)="onSortData($event)" [dataSource]="smsDataSource"
         mat-table matSort
         multiTemplateDataRows>
    
    <ng-container [matColumnDef]="tableColumns.Icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon (click)="onClickToggleIcons($event, row)"
                  *ngIf="!row.sendSmsChecked && !row[tableColumns.IsSent]"
                  class="mat-primary-color hand-cursor font-medium"
                  matTooltip="SEND sms to {{getToNumber(row)}}">send
        </mat-icon>
        
        <ng-container *ngIf="row[tableColumns.IsSent];">
          <app-duplicate (duplicateItem)="onClickDuplicate($event, row)"
                         [customCssClasses]="['hand-cursor', 'font-medium']"
                         defaultIcon="redo"
                         tooltip="RESEND sms"></app-duplicate>
        </ng-container>
        
        <mat-icon (click)="onClickSendSmsConfirmed($event, row)" *ngIf="row.sendSmsChecked"
                  class="mat-primary-color hand-cursor font-medium"
                  matTooltip="CONFIRM Send to {{getToNumber(row)}}">done
        </mat-icon>
        <mat-icon (click)="onClickToggleIcons($event, row)" *ngIf="row.sendSmsChecked"
                  class="hand-cursor font-medium"
                  color="warn"
                  matTooltip="CANCEL Send">
          close
        </mat-icon>
        
        <app-busy-spinner-icon [isBusyCounter]="row.smsSentBusyCounter"></app-busy-spinner-icon>
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.SmsId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>SMS ID</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.SmsId]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.IsSent">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Sent</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.IsSent] ? 'Y' : 'N'}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.ToNumber">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Number</th>
      <td *matCellDef="let row" mat-cell>
        <ng-container>
          <ng-container *ngIf="!row[tableColumns.IsSent];">
            <mat-icon (click)="onClickEditNumber($event, row)" *ngIf="!row?.isEditNumber"
                      class="mat-primary-color hand-cursor font-medium"
                      matTooltip="UPDATE number">edit
            </mat-icon>
          </ng-container>
          <ng-container *ngIf="row?.isEditNumber; else displayNumber">
            <mat-form-field>
              <input [formControl]="smsOverrideFormControl" matInput/>
              <button (click)="onClickCancelEditNumber($event, row)" class="mr2"
                      mat-button mat-icon-button matSuffix>
                <mat-icon matTooltip="Cancel edit" style="color: grey;">cancel</mat-icon>
              </button>
              <button (click)="onClickSaveNumber($event, row)"
                      mat-button mat-icon-button matSuffix>
                <mat-icon class="table-icon" matTooltip="Save number">save</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>
          
          <ng-template #displayNumber>
            <ng-container *ngIf="!row?.editedToNumber; else showEditedAddress">
              {{row[tableColumns.ToNumber] }}
            </ng-container>
            <ng-template #showEditedAddress>
              {{row?.editedToNumber}}
            </ng-template>
          </ng-template>
        </ng-container>
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.Message">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Message</th>
      <td *matCellDef="let row"
          [matTooltip]="row[tableColumns.Message]"
          mat-cell>{{row[tableColumns.Message] | truncateText: {sliceEnd: 30, append: '...'} }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.CommunicationTriggerType">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Communication Type</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.CommunicationTriggerType]?.name}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.TriggerId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Trigger ID</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.TriggerId]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.SmsTemplate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Class</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.SmsTemplate]?.processingClass?.name}}</td>
    </ng-container>
    
    <!-- Expanded Section -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" [attr.colspan]="smsDisplayedColumns.length" mat-cell>
        <div [@detailExpand]="row == smsExpandedRow ? 'expanded' : 'collapsed'"
             class="row-detail-container">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr *matHeaderRowDef="smsDisplayedColumns;" mat-header-row></tr>
    <tr (click)="onRowClick($event, row)"
        *matRowDef="let row; columns: smsDisplayedColumns;"
        [class.expanded-row]="smsExpandedRow == row"
        class="row"
        mat-row>
    </tr>
    <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
  </table>
  
  <mat-paginator #smsPaginator
                 (page)="onPageChanged($event)" [length]="smsTableControl.length"
                 [pageIndex]="0"
                 [pageSizeOptions]="smsTableControl.pageSizeOptions"
                 [pageSize]="smsTableControl.pageSize">
  </mat-paginator>
</div>